import { render, staticRenderFns } from "./OperaWithdrawalOrdersWindow.vue?vue&type=template&id=4b90ba52&"
import script from "./OperaWithdrawalOrdersWindow.vue?vue&type=script&lang=js&"
export * from "./OperaWithdrawalOrdersWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports